module.exports = __webpack_public_path__ + "img/play-icon-audio.11c9ea1b.svg";